export default __webpack_public_path__ + "static/media/043-chevron.a1d4a4ba.png";